import { Maybe, NewsItem } from '../../types/generated/graphql-types'
import { LatestContentItem } from '../components/LatestContent'
import { notEmpty } from '../utilities/filters'

export const newsItemToLatestContentItem = (
  pressRelease: NewsItem
): LatestContentItem | null => {
  if (!pressRelease) {
    return null
  }

  return {
    title: pressRelease.title ?? '',
    date: pressRelease.publishDate ?? '',
    url: pressRelease.path ?? '',
  }
}

export const newsItemToLatestContent = (
  newsItems: Maybe<NewsItem>[]
): LatestContentItem[] =>
  newsItems.filter(notEmpty).map(newsItemToLatestContentItem).filter(notEmpty)
